import { relations } from 'drizzle-orm';
import { integer, pgTable, primaryKey, text, varchar } from 'drizzle-orm/pg-core';
import { application } from './application';

export const applicationSetting = pgTable(
  'application_setting',
  {
    app_id: integer()
      .notNull()
      .references(() => application.id, { onDelete: 'cascade' }),
    key: varchar({ length: 255 }).notNull(),
    value: text().notNull(),
  },
  (table) => [primaryKey({ columns: [table.app_id, table.key] })],
);

export const applicationSettingsRelations = relations(applicationSetting, ({ one }) => ({
  application: one(application, {
    fields: [applicationSetting.app_id],
    references: [application.id],
  }),
}));
